import { OversightPage } from './oversight/OversightPage';

/**
 * Oversight (the design's `monitoring` view): Summary, Live Decisions and the Truth
 * Ledger. Aithora sees every building; a Facility Admin sees their own, scoped by the
 * server. Care Staff have no Oversight (the side nav hides it and the server refuses).
 */
export function Oversight() {
  return <OversightPage />;
}
